// extracted by mini-css-extract-plugin
module.exports = {"root":"IntroBlockHighlights_root__bhUjC","title":"IntroBlockHighlights_title__BLuyS","inner":"IntroBlockHighlights_inner__7rj_d","list":"IntroBlockHighlights_list__g0cQ6"};